import { EMPTY_OBJECT } from '../../../../constants/common'
import { ProfileLabelsWidgetForm } from '../../ProfileLabelsWidgetForm'
import { useWidgetContext } from '../../Widget.hooks'
import { WidgetContentItemsList } from '../../WidgetContentItemsList'
import { ProfileLabelsWidgetItem } from '../ProfileLabelsWidgetItem'

import { getLabelItemProps } from './ProfileLabelsWidgetContent.utils'

import * as styles from './ProfileLabelsWidgetContent.module.css'

function ProfileLabelsWidgetContent({
  formProps: { onClose, ...restFormProps },
  items,
  listProps: {
    Item = ProfileLabelsWidgetItem,
    itemsContainerProps: {
      className: itemsContainerClassName = styles.itemsContainer,
      ...restItemsContainerProps
    } = EMPTY_OBJECT,
    titleWrapperClassName = styles.titleWrapper,
    ...restListProps
  } = EMPTY_OBJECT,
}) {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  function handleClose() {
    handleDisableEditMode()
    onClose?.()
  }

  return (
    <>
      {isEditMode ? (
        <ProfileLabelsWidgetForm {...restFormProps} onClose={handleClose} />
      ) : null}
      {items?.length > 0 ? (
        <WidgetContentItemsList
          {...restListProps}
          Item={Item}
          getItemPropsFromValue={getLabelItemProps}
          items={items}
          itemsContainerProps={{
            ...restItemsContainerProps,
            className: itemsContainerClassName,
          }}
          titleWrapperClassName={titleWrapperClassName}
          visibleCount={items.length}
        />
      ) : null}
    </>
  )
}

export default ProfileLabelsWidgetContent
